// @ts-nocheck
import { apiRequest } from "../../services/apiService";
import {
  exportErrorsToCSV,
  exportSuccessesToCSV,
} from "../../utils/methods/other/generateCsv";
import { generateBulkUpdateResultHTML } from "../../utils/styles/defaultStyles";
import {
  ALERT_DIALOG,
  CREATE_CONTRACTORS_IN_BULK_FAILURE,
  CREATE_CONTRACTORS_IN_BULK_REQUEST,
  CREATE_CONTRACTORS_IN_BULK_SUCCESS,
  FETCH_CONTRACTOR_PROFILE_FAILURE,
  FETCH_CONTRACTOR_PROFILE_REQUEST,
  FETCH_CONTRACTOR_PROFILE_SUCCESS,
} from "../constants/auth";
import {
  ADD_CONTRACTOR_STEP1_UPDATE_FAILURE,
  ADD_PO_DATA_FAILURE,
  ADD_PO_DATA_REQUEST,
  ADD_PO_DATA_SUCCESS,
  ADD_PREFERRED_POSITION_FAILURE,
  ADD_PREFERRED_POSITION_REQUEST,
  ADD_PREFERRED_POSITION_SUCCESS,
  APPROVE_CONTRACTOR_FAILURE,
  APPROVE_CONTRACTOR_REQUEST,
  APPROVE_CONTRACTOR_SUCCESS,
  BULK_EDIT_CONTRACTOR_FAILURE,
  BULK_EDIT_CONTRACTOR_REQUEST,
  BULK_EDIT_CONTRACTOR_SUCCESS,
  BULK_UPDATE_CONTRACTOR_AND_PO_STATUS_REQUEST,
  BULK_UPDATE_CONTRACTOR_AND_PO_STATUS_SUCCESS,
  BULK_UPDATE_PO_STATUS_FAILURE,
  BULK_UPDATE_PO_STATUS_REQUEST,
  BULK_UPDATE_PO_STATUS_SUCCESS,
  CREATE_CONTRACTOR_FAILURE,
  CREATE_CONTRACTOR_REQUEST,
  CREATE_CONTRACTOR_SUCCESS,
  DELETE_CONTRACTOR_FAILURE,
  DELETE_CONTRACTOR_REQUEST,
  DELETE_CONTRACTOR_SUCCESS,
  FETCH_CONTRACTORS_FAILURE,
  FETCH_CONTRACTORS_REQUEST,
  FETCH_CONTRACTORS_SUCCESS,
  GET_PO_HISTORY_FAILURE,
  GET_PO_HISTORY_REQUEST,
  GET_PO_HISTORY_SUCCESS,
  GUSTO_APPROVE_CONTRACTOR_FAILURE,
  GUSTO_APPROVE_CONTRACTOR_REQUEST,
  GUSTO_APPROVE_CONTRACTOR_SUCCESS,
  REMOVE_PREFERRED_POSITION_FAILURE,
  REMOVE_PREFERRED_POSITION_REQUEST,
  REMOVE_PREFERRED_POSITION_SUCCESS,
  RESEND_SIGNUP_SMS_LINK_FAILURE,
  RESEND_SIGNUP_SMS_LINK_REQUEST,
  RESEND_SIGNUP_SMS_LINK_SUCCESS,
  RESET_CONTRACTOR_PASSWORD_FAILURE,
  RESET_CONTRACTOR_PASSWORD_REQUEST,
  RESET_CONTRACTOR_PASSWORD_SUCCESS,
  TOGGLE_ADP_STATUS_FAILURE,
  TOGGLE_ADP_STATUS_REQUEST,
  TOGGLE_ADP_STATUS_SUCCESS,
  TOGGLE_CONTRACTOR_STATUS_FAILURE,
  TOGGLE_CONTRACTOR_STATUS_REQUEST,
  TOGGLE_CONTRACTOR_STATUS_SUCCESS,
  TOGGLE_ONBOARDING_STATUS_FAILURE,
  TOGGLE_ONBOARDING_STATUS_REQUEST,
  TOGGLE_ONBOARDING_STATUS_SUCCESS,
  UPDATE_CONTRACTOR_FAILURE,
  UPDATE_CONTRACTOR_REQUEST,
  UPDATE_CONTRACTOR_SUCCESS,
  UPDATE_LOCAL_PO_STATUS_OF_POSITIONS,
  UPDATE_PO_PAYMENT_STATUS_FAILURE,
  UPDATE_PO_PAYMENT_STATUS_REQUEST,
  UPDATE_PO_PAYMENT_STATUS_SUCCESS,
  UPDATE_PO_VIEW_STATUS_FAILURE,
  UPDATE_PO_VIEW_STATUS_REQUEST,
  UPDATE_PO_VIEW_STATUS_SUCCESS,
  UPLOAD_CONTRACTOR_IMAGE_FAILURE,
  UPLOAD_CONTRACTOR_IMAGE_REQUEST,
  UPLOAD_CONTRACTOR_IMAGE_SUCCESS,
  UPLOAD_REQUIRED_DOCUMENTS_FAILURE,
  UPLOAD_REQUIRED_DOCUMENTS_REQUEST,
  UPLOAD_REQUIRED_DOCUMENTS_SUCCESS,
} from "../constants/contractor";
import {
  ADD_CONTRACTOR_EMAIL_FAILURE,
  ADD_CONTRACTOR_EMAIL_REQUEST,
  ADD_CONTRACTOR_EMAIL_SUCCESS,
  ADD_STEP_1_FROM_API_FAILURE,
  ADD_STEP_1_FROM_API_REQUEST,
  ADD_STEP_1_FROM_API_SUCCESS,
} from "../constants/contractorSignup";
import { alertDialogAciton } from "./auth";

// get contractors actions
export const fetchContractorsAction = ({
  payload,
  params,
  successCallback,
}) => {
  return async (dispatch) => {
    dispatch({
      type: FETCH_CONTRACTORS_REQUEST,
      payload: {
        search: payload?.searchText || "",
        airportFilters: payload?.airportFilters,
        searchBy: payload?.searchBy,
        crewFilter: payload?.crewFilter,
      },
    });
    // const URL = payload?.fullName
    //   ? `getAllContractors?search=${payload?.fullName}&page=${payload.page}${payload?.limit ? `&limit=${payload?.limit}` : ''}`
    //   : `getAllContractors?page=${payload?.page}${payload?.limit ? `&limit=${payload?.limit}` : ''}`;
    const URL = `getAllContractors`;
    const { response, error } = await apiRequest({
      method: "GET",
      url: URL,
      data: null,
      params: {
        ...params,
        searchAirport: [
          ...(payload?.airportFilters?.localAirports?.map(
            (item) => item?.airportName,
          ) || []),
          ...(payload?.airportFilters?.additionalAirports?.map(
            (item) => item?.airportName,
          ) || []),
        ]?.join(", "),
        radius: payload?.airportFilters?.radius,
      },
      // version: "v3",
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({ type: FETCH_CONTRACTORS_SUCCESS, payload: response?.data });
      if (successCallback) successCallback();
    } else if (error || response?.status !== 200) {
      dispatch({ type: FETCH_CONTRACTORS_FAILURE });
    }
  };
};

export const getAllContractorsAction = ({
  payload,
  params,
  beforeCallback,
  afterCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    if (beforeCallback) {
      beforeCallback();
    }

    // const URL = payload?.fullName
    //   ? `getAllContractors?search=${payload?.fullName}&page=${payload.page}${payload?.limit ? `&limit=${payload?.limit}` : ''}`
    //   : `getAllContractors?page=${payload?.page}${payload?.limit ? `&limit=${payload?.limit}` : ''}`;
    const URL = `getAllContractors`;
    const { response, error } = await apiRequest({
      method: "GET",
      url: URL,
      data: null,
      params,
      // version: "v3",
      isToken: true,
    });

    if (afterCallback) {
      afterCallback();
    }

    if (response?.status === 200) {
      if (successCallback)
        successCallback({
          response,
        });
    } else if (error || response?.status !== 200) {
      if (failureCallback) {
        failureCallback({
          error,
        });
      }
    }
  };
};

// toggle contractor status actions
export const toggleContractorStatusAction = (payload, successCallback) => {
  return async (dispatch) => {
    dispatch({ type: TOGGLE_CONTRACTOR_STATUS_REQUEST });
    const { response, error } = await apiRequest({
      method: "PATCH",
      url: `updateContractorIsActive/${payload.id}`,
      data: { isActive: payload.isActive },
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({
        type: TOGGLE_CONTRACTOR_STATUS_SUCCESS,
        payload: response?.data?.data,
      });
      successCallback?.();
    } else if (error || response?.status !== 200) {
      dispatch({ type: TOGGLE_CONTRACTOR_STATUS_FAILURE });
    }
  };
};

// toggle contractorType action
export const toggleContractorTypeAction = ({
  beforeCallback,
  successCallback,
  failureCallback,
  params,
  payload,
}) => {
  return async (dispatch, getState) => {
    if (beforeCallback) {
      beforeCallback();
    }

    const { error, response } = await apiRequest({
      method: "PATCH",
      url: `toggleContractorType`,
      data: payload,
      params,
      isToken: true,
    });

    if (response) {
      if (successCallback) {
        successCallback({ response });
      }
    } else {
      if (failureCallback) {
        failureCallback({ error });
      }
    }
  };
};

// update contractor certificate toggle action
export const updateContractorCertificateValuesAction = ({
  params,
  payload,
  beforeCallback,
  afterResponseCallback,
  successCallback,
  failureCallback,
}) => {
  return async () => {
    if (beforeCallback) {
      beforeCallback();
    }

    const { error, response } = await apiRequest({
      method: "PATCH",
      url: "updateCertificateValue",
      params,
      data: payload,
      isToken: true,
    });

    if (afterResponseCallback) {
      afterResponseCallback();
    }

    if (response) {
      if (successCallback) {
        successCallback({
          response,
        });
      } else {
        if (failureCallback) {
          failureCallback({
            error,
          });
        }
      }
    } else {
      if (failureCallback) {
        failureCallback({
          error,
        });
      }
    }
  };
};

export const updateContractorCertificateFilesAction = ({
  tempToken,
  params,
  payload,
  beforeCallback,
  afterResponseCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    if (beforeCallback) {
      beforeCallback();
    }

    const { error, response } = await apiRequest({
      method: "PUT",
      url: "uploadCertificateFile",
      params,
      data: payload,
      isToken: true,
      tempToken,
    });

    if (afterResponseCallback) {
      afterResponseCallback();
    }

    if (response) {
      if (successCallback) {
        // dispatch({
        //   type: UPDATE_CONTRACTOR_CERTIFICATES,
        //   payload: response?.data?.data
        // })

        successCallback({
          response,
        });
      } else {
        if (failureCallback) {
          failureCallback({
            error,
          });
        }
      }
    } else {
      if (failureCallback) {
        failureCallback({
          error,
        });
      }
    }
  };
};

// delete contractor certificate files...
export const deleteContractorCertificateFilesAction = ({
  tempToken,
  params,
  payload,
  beforeCallback,
  afterResponseCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    if (beforeCallback) {
      beforeCallback();
    }

    const { error, response } = await apiRequest({
      method: "PATCH",
      url: "emptyCertificateFiles",
      params,
      data: payload,
      isToken: true,
      tempToken,
    });

    if (afterResponseCallback) {
      afterResponseCallback();
    }

    if (response) {
      // dispatch({
      //   type: UPDATE_CONTRACTOR_CERTIFICATES,
      //   payload: response?.data?.data
      // })

      if (successCallback) {
        successCallback({
          response,
        });
      }
    } else {
      if (failureCallback) {
        failureCallback({
          error,
        });
      }
    }
  };
};

// delete contractor action
export const deleteContractorAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_CONTRACTOR_REQUEST });
    const { response, error } = await apiRequest({
      method: "PATCH",
      url: `deleteContractor/${payload.id}`,
      data: null,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({ type: DELETE_CONTRACTOR_SUCCESS, payload: payload.id });
      if (successCallback) {
        successCallback();
      }
    } else if (error || response?.status !== 200) {
      dispatch({ type: DELETE_CONTRACTOR_FAILURE });
      if (failureCallback) {
        failureCallback({ error });
      }
    }
  };
};

// crate contractor action
export const createContractorAction = (payload, successCallback) => {
  return async (dispatch) => {
    dispatch({ type: CREATE_CONTRACTOR_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `createContractor`,
      data: payload,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({
        type: CREATE_CONTRACTOR_SUCCESS,
        payload: response?.data?.data,
      });
      if (successCallback)
        successCallback({
          newContractor: response?.data?.data,
        });
    } else if (error || response?.status !== 200) {
      dispatch({ type: CREATE_CONTRACTOR_FAILURE });
      dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          title: "Error",
          message: error?.response?.data?.message,
        },
      });
    }
  };
};

// update contractor action
export const updateContractorAction = (payload, successCallback) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_CONTRACTOR_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: `updateContractor/${payload.id}`,
      data: payload?.updateData,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({ type: UPDATE_CONTRACTOR_SUCCESS });
      if (successCallback)
        successCallback({
          newContractor: response?.data?.data,
        });
    } else if (response?.status !== 200 || error) {
      dispatch({ type: UPDATE_CONTRACTOR_FAILURE });
    }
  };
};

// upload contractor image
export const uploadContractorImageAction = ({
  newContractor,
  payload,
  successCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: UPLOAD_CONTRACTOR_IMAGE_REQUEST });

    const { response, error } = await apiRequest({
      method: "PATCH",
      url: `uploadImageContractor/${newContractor?._id}`,
      data: payload,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: UPLOAD_CONTRACTOR_IMAGE_SUCCESS });
      if (successCallback) {
        successCallback();
      }
    } else {
      dispatch({ type: UPLOAD_CONTRACTOR_IMAGE_FAILURE });
      dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          title: "Error!",
          message:
            error?.message || "Some error occured in uploading the image",
        },
      });
    }
  };
};

// add preferred position
export const addPreferredPositionAction = (
  payload,
  successCallback,
  failureCallback,
) => {
  return async (dispatch) => {
    dispatch({ type: ADD_PREFERRED_POSITION_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: `addPreferredPositions/${payload?.contractorId}`,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: ADD_PREFERRED_POSITION_SUCCESS });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: ADD_PREFERRED_POSITION_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

// remove preferred position
export const removePreferredPostionAction = (
  payload,
  successCallback,
  failureCallback,
) => {
  return async (dispatch) => {
    dispatch({ type: REMOVE_PREFERRED_POSITION_REQUEST });
    const { response, error } = await apiRequest({
      method: "PATCH",
      url: `removePreferredPosition/${payload?.contractorId}`,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: REMOVE_PREFERRED_POSITION_SUCCESS });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: REMOVE_PREFERRED_POSITION_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

// approve contractor
export const approveContractorAction = (payload, successCallback) => {
  return async (dispatch) => {
    dispatch({ type: APPROVE_CONTRACTOR_REQUEST });
    const { response, error } = await apiRequest({
      method: "PATCH",
      url: `approveContractor/${payload?.id}`,
      data: { isApproved: payload?.isApproved },
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({
        type: APPROVE_CONTRACTOR_SUCCESS,
        payload: { id: payload?.id, data: response?.data?.data },
      });
      if (successCallback) successCallback({});
    } else if (response?.status !== 200 || error) {
      dispatch({ type: APPROVE_CONTRACTOR_FAILURE });
    }
  };
};

// approve contractor
export const gustoApproveContractorAction = (
  payload,
  successCallback,
  failureCallback,
) => {
  return async (dispatch) => {
    dispatch({ type: GUSTO_APPROVE_CONTRACTOR_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: `gustoApproveContractor`,
      params: {
        contractorId: payload.id,
      },
      data: null,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({
        type: GUSTO_APPROVE_CONTRACTOR_SUCCESS,
        payload: payload?.id,
      });
      if (successCallback) successCallback(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: GUSTO_APPROVE_CONTRACTOR_FAILURE });
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};

// gusto approve toggle
export const gustoApproveToggleContractorAction = (
  payload,
  successCallback,
  failureCallback,
) => {
  return async (dispatch) => {
    dispatch({ type: GUSTO_APPROVE_CONTRACTOR_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: `toggleGustoContractor`,
      params: {
        contractorId: payload.id,
      },
      data: null,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({
        type: GUSTO_APPROVE_CONTRACTOR_SUCCESS,
        payload: payload?.id,
      });
      if (successCallback) successCallback(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: GUSTO_APPROVE_CONTRACTOR_FAILURE });
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};

// get full contractor details...
export const getContractorByIdAction = ({
  contractorId,
  successCallback,
  failureCallback,
  afterResponseCallback,
}) => {
  return async (dispatch) => {
    const { response, error } = await apiRequest({
      method: "GET",
      url: `getContractorById/${contractorId}`,
      isToken: true,
    });

    if (response) {
      // dispatch({
      //   type: ADD_CONTRACTOR_STEP1_SUCCESS,
      //   payload: {
      //     data: response.data?.data,
      //     formData
      //   }
      // });

      if (successCallback)
        successCallback({
          response,
        });
    } else if (error) {
      // dispatch({ type: ADD_CONTRACTOR_STEP1_FAILURE });
      if (failureCallback)
        failureCallback({
          error,
        });
    }

    if (afterResponseCallback) {
      afterResponseCallback();
    }
  };
};

export const addContractorsBulkAction = ({
  payload,
  successCallback,
  failureCallback,
  beforeResponseCallback,
  afterResponseCallback,
}) => {
  return async (dispatch, getState) => {
    // dispatch({ type: ADD_CONTRACTOR_STEP1_REQUEST });

    dispatch({
      type: CREATE_CONTRACTORS_IN_BULK_REQUEST,
    });

    if (beforeResponseCallback) {
      beforeResponseCallback();
    }

    const { response, error } = await apiRequest({
      method: "POST",
      url: `addPersonalInformation`,
      data: payload,
      isToken: true,
    });

    if (response?.data?.data?.length > 0) {
      dispatch({
        type: CREATE_CONTRACTORS_IN_BULK_SUCCESS,
      });
      // dispatch({
      //   type: ADD_CONTRACTOR_STEP1_SUCCESS,
      //   payload: {
      //     data: response.data?.data,
      //     formData
      //   }
      // });
      if (successCallback)
        successCallback({
          response,
        });
    } else {
      // dispatch({ type: ADD_CONTRACTOR_STEP1_FAILURE });
      dispatch({
        type: CREATE_CONTRACTORS_IN_BULK_FAILURE,
      });

      if (failureCallback)
        failureCallback({
          error: response?.data?.errors,
        });
    }

    if (afterResponseCallback) {
      afterResponseCallback();
    }
  };
};

export const addContractorStep1Action = ({
  sendToken,
  payload,
  formData,
  successCallback,
  failureCallback,
  afterResponseCallback,
  isProvisionalContractor,
}) => {
  return async (dispatch, getState) => {
    // dispatch({ type: ADD_CONTRACTOR_STEP1_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: isProvisionalContractor
        ? "signupTemporaryContractor"
        : payload?.is3rdParty
          ? "add3rdPartyOutSourceContractor"
          : sendToken
            ? `addPersonalInformation`
            : `selfSignup`,
      data: payload,
      isToken: Boolean(sendToken),
      version: isProvisionalContractor
        ? "v6"
        : !isProvisionalContractor && !payload?.is3rdParty
          ? "v6"
          : "v5",
    });

    if (response?.status === 200) {
      // dispatch({
      //   type: ADD_CONTRACTOR_STEP1_SUCCESS,
      //   payload: {
      //     data: response.data?.data,
      //     formData
      //   }
      // });
      if (successCallback)
        successCallback({
          response,
        });
    } else if (response?.status !== 200 || error) {
      // dispatch({ type: ADD_CONTRACTOR_STEP1_FAILURE });
      if (failureCallback)
        failureCallback({
          error,
        });
    }

    if (afterResponseCallback) {
      afterResponseCallback();
    }
  };
};

export const addContractorStep1UpdateAction = ({
  tempToken,
  contractorId,
  payload,
  formData,
  sendToken,
  successCallback,
  failureCallback,
  afterResponseCallback,
  isProfileUpdate = false,
}) => {
  return async (dispatch, getState) => {
    // dispatch({ type: ADD_CONTRACTOR_STEP1_UPDATE_REQUEST });
    if (isProfileUpdate) {
      dispatch({ type: FETCH_CONTRACTOR_PROFILE_REQUEST });
    }
    const { response, error } = await apiRequest({
      method: "PUT",
      url: `editPersonalInformation/${contractorId}`,
      data: payload,
      isToken: true,
      tempToken,
    });

    if (response?.status === 200) {
      // dispatch({
      //   type: ADD_CONTRACTOR_STEP1_UPDATE_SUCCESS,
      //   payload: {
      //     data: response.data?.data,
      //     formData
      //   }
      // });
      if (isProfileUpdate) {
        dispatch({
          type: FETCH_CONTRACTOR_PROFILE_SUCCESS,
          payload: response?.data?.data,
        });
      }
      if (successCallback)
        successCallback({
          response,
        });
    } else if (response?.status !== 200 || error) {
      if (isProfileUpdate) {
        dispatch({
          type: FETCH_CONTRACTOR_PROFILE_FAILURE,
        });
      }
      if (failureCallback) {
        failureCallback({
          error,
        });
      }
      // dispatch({ type: ADD_CONTRACTOR_STEP1_UPDATE_FAILURE });
    }

    if (afterResponseCallback) {
      afterResponseCallback();
    }
  };
};

export const addContractorStep2Action = ({
  tempToken,
  payload,
  contractorId,
  formData,
  successCallback,
  failureCallback,
  afterResponseCallback,
}) => {
  return async (dispatch, getState) => {
    // dispatch({ type: ADD_CONTRACTOR_STEP2_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: `addRoleInformation/${contractorId}`,
      data: payload,
      isToken: true,
      tempToken,
    });

    if (response?.status === 200) {
      // dispatch({
      //   type: ADD_CONTRACTOR_STEP2_SUCCESS,
      //   payload: {
      //     data: response?.data?.data,
      //     formData
      //   }
      // });
      if (successCallback)
        successCallback({
          response,
        });
    } else if (response?.status !== 200 || error) {
      if (failureCallback)
        failureCallback({
          error,
        });
      // dispatch({ type: ADD_CONTRACTOR_STEP2_FAILURE });
    }

    if (afterResponseCallback) {
      afterResponseCallback();
    }
  };
};

export const addContractorStep3Action = ({
  tempToken,
  payload,
  contractorId,
  formData,
  successCallback,
  failureCallback,
  afterResponseCallback,
}) => {
  return async (dispatch, getState) => {
    // dispatch({ type: ADD_CONTRACTOR_STEP3_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: `addCareerGoals/${contractorId}`,
      data: payload,
      isToken: true,
      tempToken,
    });

    if (response?.status === 200) {
      // dispatch({
      //   type: ADD_CONTRACTOR_STEP3_SUCCESS,
      //   payload: {
      //     data: response?.data?.data,
      //     formData
      //   }
      // });
      if (successCallback)
        successCallback({
          response,
        });
    } else if (response?.status !== 200 || error) {
      // dispatch({ type: ADD_CONTRACTOR_STEP3_FAILURE });
    }

    if (afterResponseCallback) {
      afterResponseCallback();
    }
  };
};

export const addContractorStep4Action = ({
  tempToken,
  payload,
  contractorId,
  formData,
  successCallback,
  failureCallback,
  afterResponseCallback,
}) => {
  return async (dispatch, getState) => {
    // dispatch({ type: ADD_CONTRACTOR_STEP4_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: `addRoleExperience/${contractorId}`,
      data: payload,
      isToken: true,
      tempToken,
    });

    if (response?.status === 200) {
      // dispatch({
      //   type: ADD_CONTRACTOR_STEP4_SUCCESS,
      //   payload: {
      //     data: response?.data?.data,
      //     formData
      //   }
      // });
      if (successCallback)
        successCallback({
          response,
        });
    } else if (response?.status !== 200 || error) {
      // dispatch({ type: ADD_CONTRACTOR_STEP4_FAILURE });
      if (failureCallback) failureCallback();
    }

    if (afterResponseCallback) {
      afterResponseCallback();
    }
  };
};

export const addInviteContractorAction = ({
  tempToken,
  payload,
  contractorId,
  formData,
  beforeCallback,
  successCallback,
  failureCallback,
  afterResponseCallback,
}) => {
  return async (dispatch, getState) => {
    // dispatch({ type: ADD_CONTRACTOR_STEP4_REQUEST });

    if (beforeCallback) {
      beforeCallback();
    }

    const { response, error } = await apiRequest({
      method: "POST",
      url: `addInviteContractor`,
      data: payload,
      isToken: true,
      tempToken,
    });

    if (afterResponseCallback) {
      afterResponseCallback();
    }

    if (response) {
      // dispatch({
      //   type: ADD_CONTRACTOR_STEP4_SUCCESS,
      //   payload: {
      //     data: response?.data?.data,
      //     formData
      //   }
      // });
      if (successCallback)
        successCallback({
          response,
        });
    } else if (response?.status !== 200 || error) {
      // dispatch({ type: ADD_CONTRACTOR_STEP4_FAILURE });
      if (failureCallback)
        failureCallback({
          error,
        });
    }
  };
};

export const addContractorAction = ({
  isOutSourced,
  tempToken,
  payload,
  contractorId,
  formData,
  beforeCallback,
  successCallback,
  failureCallback,
  afterResponseCallback,
}) => {
  return async (dispatch, getState) => {
    // dispatch({ type: ADD_CONTRACTOR_STEP4_REQUEST });

    if (beforeCallback) {
      beforeCallback();
    }

    const { response, error } = await apiRequest({
      method: "POST",
      url: isOutSourced ? "addOutsourcedContractor" : `addContractor`,
      data: payload,
      isToken: true,
      tempToken,
      version: isOutSourced ? "v5" : "v6",
    });

    if (response) {
      // dispatch({
      //   type: ADD_CONTRACTOR_STEP4_SUCCESS,
      //   payload: {
      //     data: response?.data?.data,
      //     formData
      //   }
      // });
      if (successCallback)
        successCallback({
          response,
        });
    } else if (response?.status !== 200 || error) {
      // dispatch({ type: ADD_CONTRACTOR_STEP4_FAILURE });
      if (failureCallback)
        failureCallback({
          error,
        });
    }

    if (afterResponseCallback) {
      afterResponseCallback();
    }
  };
};

export const respondToMulOpportunities = ({
  tempToken,
  params,
  payload,
  beforeCallback,
  successCallback,
  failureCallback,
  afterResponseCallback,
}) => {
  return async (dispatch, getState) => {
    // dispatch({ type: ADD_CONTRACTOR_STEP4_REQUEST });

    if (beforeCallback) {
      beforeCallback();
    }

    const { response, error } = await apiRequest({
      method: "PUT",
      url: `acceptDeclineMulOpportunities`,
      data: payload,
      params,
      isToken: true,
      tempToken,
    });

    if (afterResponseCallback) {
      afterResponseCallback();
    }

    if (response) {
      // dispatch({
      //   type: ADD_CONTRACTOR_STEP4_SUCCESS,
      //   payload: {
      //     data: response?.data?.data,
      //     formData
      //   }
      // });
      if (successCallback) {
        successCallback({
          response,
        });
      }
    } else if (response?.status !== 200 || error) {
      // dispatch({ type: ADD_CONTRACTOR_STEP4_FAILURE });
      if (failureCallback)
        failureCallback({
          error,
        });
    }
  };
};

// upload required documents action
export const uploadRequiredDocumentAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: UPLOAD_REQUIRED_DOCUMENTS_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: "uploadRequiredDocuments",
      params: payload?.params,
      data: payload?.data,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({ type: UPLOAD_REQUIRED_DOCUMENTS_SUCCESS });
      successCallback?.(response?.data?.data?.requiredDocuments);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: UPLOAD_REQUIRED_DOCUMENTS_FAILURE });
      failureCallback?.(error?.response?.data?.message);
    }
  };
};

/**
 * toggle onboarding status
 */
export const toggleOnboardingStatusAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: TOGGLE_ONBOARDING_STATUS_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: "toggleOnboardingContractor",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status == 200) {
      dispatch({ type: TOGGLE_ONBOARDING_STATUS_SUCCESS });
      successCallback?.(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: TOGGLE_ONBOARDING_STATUS_FAILURE });
      failureCallback?.(error?.response?.data?.message);
    }
  };
};

/**
 * add po data action
 */
export const addPoDataAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: ADD_PO_DATA_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: "addPOData",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status == 200) {
      dispatch({ type: ADD_PO_DATA_SUCCESS });
      successCallback?.();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: ADD_PO_DATA_FAILURE });
      // The server now refuses with a reason (doc 20: 400 gate / 409 already
      // sent) — hand it to the caller so the page can show it.
      failureCallback?.({ error, response });
    }
  };
};

/**
 * update po view status
 */
export const updatePOViewStatusAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_PO_VIEW_STATUS_REQUEST });
    const { response, error } = await apiRequest({
      method: "PATCH",
      url: "updateSavedPOStatus",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });
    if (response?.status == 200) {
      dispatch({ type: UPDATE_PO_VIEW_STATUS_SUCCESS });
      if (payload?.updateLocal) {
        dispatch({
          type: UPDATE_LOCAL_PO_STATUS_OF_POSITIONS,
          payload: response?.data?.updatedPO,
        });
      }
      successCallback?.(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: UPDATE_PO_VIEW_STATUS_FAILURE });
      failureCallback?.(error?.response?.data?.message);
    }
  };
};

/**
 * v4/POPaymentScheduledStatus?POId=68cd65c504e2bb7e35ae3917
Method=Patch
Payload
{
    "scheduledDate":"2025-10-31T14:16:37.848+00:00"
}
 */
export const updatePOPaymentScheduleStatus = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_PO_PAYMENT_STATUS_REQUEST });
    const { response, error } = await apiRequest({
      method: "PATCH",
      url: "POPaymentScheduledStatus",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status == 200) {
      dispatch({
        type: UPDATE_PO_PAYMENT_STATUS_SUCCESS,
      });
      if (payload?.updateLocal) {
        dispatch({
          type: UPDATE_LOCAL_PO_STATUS_OF_POSITIONS,
          payload: response?.data?.updatedPO,
        });
      }
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Success",
          message: response?.data?.message || "PO status updated",
        }),
      );
      if (successCallback) successCallback(response?.data);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: UPDATE_PO_PAYMENT_STATUS_FAILURE });
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Failure",
          message:
            error?.response?.data?.message || "Failed to updated PO status.",
        }),
      );
      if (failureCallback) failureCallback(error?.response?.data);
    }
  };
};

/**
 * add new step 1 form data
 * api/v4/getProvisionalContractor?provisionalContractorId=696b8755599376a416acf7fe
 */
export const addNewStep1FormDataFromApiAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: ADD_STEP_1_FROM_API_REQUEST });
    const { response, error } = await apiRequest({
      method: "GET",
      url: "getContractorById",
      data: payload?.data,
      params: payload?.params,
      isToken: false,
    });

    if (response?.status == 200) {
      dispatch({ type: ADD_STEP_1_FROM_API_SUCCESS, payload: response?.data });
      successCallback?.({ res: response?.data?.data });
    } else if (response?.status !== 200 || error) {
      dispatch({ type: ADD_STEP_1_FROM_API_FAILURE });
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message: error?.response?.data?.message,
        }),
      );
      failureCallback?.();
    }
  };
};

/**
 * resend signup sms link action
 * api/v5/sendSignupLinkViaSms?contractorId=68c996edf34f81ed7a992a8a
 */
export const resendSignupSmsLinkAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: RESEND_SIGNUP_SMS_LINK_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: "sendSignupLinkViaSms",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status == 200) {
      dispatch({ type: RESEND_SIGNUP_SMS_LINK_SUCCESS });
      successCallback?.();
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Success",
          message: response?.data?.message || "Signup link send through SMS.",
        }),
      );
    } else if (response?.status !== 200 || error) {
      dispatch({ type: RESEND_SIGNUP_SMS_LINK_FAILURE });
      failureCallback?.();
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message: error?.resopnse?.data?.message || "Failed to send SMS.",
        }),
      );
    }
  };
};

/**
 * add contractor email 
 * v5/addContractorEmail?contractorId=696f87add0be97bdd2dfa275
Payload
{
    "email":"barkatmalik67@yopmail.com"
}
 
Method=Put
 */
export const addContractorEmailAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: ADD_CONTRACTOR_EMAIL_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: "addContractorEmail",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status == 200) {
      dispatch({ type: ADD_CONTRACTOR_EMAIL_SUCCESS });
      successCallback?.({ res: response?.data });
    } else if (response?.status !== 200 || error) {
      dispatch({ type: ADD_CONTRACTOR_STEP1_UPDATE_FAILURE });
      failureCallback?.();
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message:
            error?.response?.data?.message || "Failed to add contractor email",
        }),
      );
    }
  };
};

/**
 * 
    const { response, error } = await apiRequest({
      method: "GET",
      url: "getEmailLinkData",
      params: payload?.params,
      isToken: true,
    });
 */
export const getEmailLinkDataFromRedisIdAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    const { response, error } = await apiRequest({
      method: "GET",
      url: "getEmailLinkData",
      params: payload?.params,
      isToken: true,
    });
    if (response?.status == 200) {
      successCallback?.({ res: response?.data?.data });
    } else if (response?.status !== 200 || error) {
      failureCallback?.();
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message: error?.response?.data?.message || "Failed to fetch data",
        }),
      );
    }
  };
};

/**
 * api/v3/getSavedPOHistory?eventId=688a0901ef0cdeaba443831e&contractorId=68c996edf34f81ed7a992a8a
 */
export const getAllPOHistoryAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: GET_PO_HISTORY_REQUEST });
    const { response, error } = await apiRequest({
      method: "GET",
      url: "getSavedPOHistory",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status == 200) {
      dispatch({ type: GET_PO_HISTORY_SUCCESS, payload: response?.data });
      successCallback?.({ response });
    } else if (response?.status !== 200 || error) {
      dispatch({ type: GET_PO_HISTORY_FAILURE });
      failureCallback?.({ res: error?.response });
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message: error?.response?.data?.message || "Failed to get PO history",
        }),
      );
    }
  };
};

/**
 * api/v3/toggleADP?contractorId=68c996edf34f81ed7a992a8a
Method=Put
 */
export const toggleAdpStatusAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: TOGGLE_ADP_STATUS_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: "toggleADP",
      params: payload?.params,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status == 200) {
      dispatch({ type: TOGGLE_ADP_STATUS_SUCCESS });
      // dispatch(
      //   alertDialogAciton({
      //     open: true,
      //     title: "Success",
      //     message: response?.data?.message || "ADP Status update successfully",
      //   }),
      // );
      successCallback?.({ response });
    } else if (response?.status != 200 || error) {
      dispatch({ type: TOGGLE_ADP_STATUS_FAILURE });
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Failure",
          message:
            error?.response?.data?.message || "Failed to update ADP status",
        }),
      );
      failureCallback?.();
    }
  };
};

/**
 * bulk edit contractors
 *
 * api/v4/bulkEditContractors
 
Method=Put
 
Paylaod
{
  "payload": [
    {
        "id":"69e3e4d8939724269a99fe8a",
      "contractorType": "1099",
      "triggerEmail": true,
      "isApproved": true
    //   "isGustoApproved": true,
    //   "isActive":true,
    //   "isADPCompleted":false,
    //   "isContractorFlagged":false,
    //   "isContractorRestricted":false
    // "sendEmailConsent":true,
    // "sendSmsConsent":true
    },
    {
        "id":"69e39164590de844eb4d3ee4",
      "contractorType": "w2",
      "triggerEmail": false,
      "isApproved": true
    //   "isGustoApproved": true,
    //   "isActive":true,
    //   "isADPCompleted":false,
    //   "isContractorFlagged":false,
    //   "isContractorRestricted":false,
    // "sendEmailConsent":true,
    // "sendSmsConsent":true
    }
  ]
}

 */
export const bulkUpddateContractorAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: BULK_EDIT_CONTRACTOR_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: "bulkEditContractors",
      data: payload,
      isToken: true,
    });

    if (response?.status == 200) {
      dispatch({ type: BULK_EDIT_CONTRACTOR_SUCCESS });

      if (response?.data?.errors.length > 0) {
        window.exportErrorsToCSV = () =>
          exportErrorsToCSV(response?.data?.errors || []);
      }

      if (response?.data?.successDetails.length > 0) {
        window.exportSuccessesToCSV = () =>
          exportSuccessesToCSV(response?.data?.successDetails || []);
      }

      dispatch(
        alertDialogAciton({
          open: true,
          title: "Success",
          maxWidth: "md",
          message:
            generateBulkUpdateResultHTML({
              summary: response?.data?.summary,
              errors: response?.data?.errors,
              additionalMessage: response?.data?.message,
              successes: response?.data?.successDetails,
            }) || "Contractor's data udpated",
        }),
      );
      successCallback?.({ updatedRows: response?.data?.successDetails });
    } else if (response?.status !== 200 || error) {
      dispatch({ type: BULK_EDIT_CONTRACTOR_FAILURE });
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Failure",
          message:
            error?.response?.data?.message ||
            "Failed to udpate contractor's data",
        }),
      );
      failureCallback?.();
    }
  };
};

/**
 * bulk update po status
 * api/v5/bulkUpdatePOStatus
 
Method=Put
 */
export const bulkUpdatePOStatusAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: BULK_UPDATE_PO_STATUS_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: "bulkUpdatePOStatus",
      data: payload,
      isToken: true,
    });

    if (response?.status == 200) {
      dispatch({ type: BULK_UPDATE_PO_STATUS_SUCCESS });
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Success",
          message: response?.data?.message || "PO Status updated",
          // generateBulkUpdateResultHTML({
          //   summary: response?.data?.summary,
          //   errors: response?.data?.errors,
          //   additionalMessage: response?.data?.message,
          // }) || "Contractor's data udpated",
        }),
      );
      successCallback?.();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: BULK_UPDATE_PO_STATUS_FAILURE });
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Failure",
          message:
            error?.response?.data?.message || "Failed to udpate PO status",
        }),
      );
      failureCallback?.();
    }
  };
};

/**
 * bulk update po status and contractor udpate
 *
 * api/v4/bulkEditContractors && api/v5/bulkUpdatePOStatus
 */
export const bulkUpdateContractorAndPOStatusAction = ({
  contractorPayload,
  poPayload,
  successCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: BULK_UPDATE_CONTRACTOR_AND_PO_STATUS_REQUEST });

    // 04/08: `poStatus`/`paidDate` são tratados SÓ pelo bulkUpdatePOStatus. Quando
    // o usuário escolhe apenas "PO Status" no Bulk Edit, o contractorPayload fica
    // com esses dois campos e mais nada — e disparar bulkEditContractors com isso
    // só produzia um "contractorIds required" vermelho no topo do resumo, ao lado
    // de um update de PO que deu certo. Espelha o guard que o poPayload já tinha.
    const PO_ONLY_FIELDS = ["id", "poStatus", "paidDate"];
    const hasContractorFields = (contractorPayload?.payload ?? []).some((row) =>
      Object.keys(row || {}).some((k) => !PO_ONLY_FIELDS.includes(k)),
    );

    // ⚠️ `apiRequest(...)` dispara a chamada na hora em que é avaliado — por isso
    // as requests só são criadas DENTRO do condicional, não antes dele.
    const [contractorUpdateResponse, poUpdateResonse] = await Promise.all([
      hasContractorFields
        ? apiRequest({
            method: "PUT",
            url: "bulkEditContractors",
            data: contractorPayload,
            isToken: true,
          })
        : Promise.resolve({}),
      ...(poPayload?.poPayload?.length > 0
        ? [
            apiRequest({
              method: "PUT",
              url: "bulkUpdatePOStatus",
              data: poPayload,
              isToken: true,
            }),
          ]
        : []),
    ]);
    let contractorResponseMessage = "";
    let poResponseMessage = "";

    if (contractorUpdateResponse?.response?.status == 200) {
      const { response } = contractorUpdateResponse;

      if (response?.data?.errors?.length > 0) {
        window.exportErrorsToCSV = () =>
          exportErrorsToCSV(response?.data?.errors || []);
      }

      if (response?.data?.successDetails?.length > 0) {
        window.exportSuccessesToCSV = () =>
          exportSuccessesToCSV(response?.data?.successDetails || []);
      }
      contractorResponseMessage = generateBulkUpdateResultHTML({
        additionalHeader: "Contractor Updates",
        additionalMessage: response?.data?.message,
        summary: response?.data?.summary,
        successes: response?.data?.successDetails,
        errors: response?.data?.errors,
      });
    } else if (contractorUpdateResponse?.error) {
      const { error } = contractorUpdateResponse;
      contractorResponseMessage = generateBulkUpdateResultHTML({
        additionalHeader: "Contractor Updates",
        additionalMessage: error?.response?.data?.message,
      });
    }

    if (poUpdateResonse?.response?.status == 200) {
      const { response } = poUpdateResonse;

      if (response?.data?.errors?.length > 0) {
        window.exportPOErrorsToCSV = () =>
          exportErrorsToCSV(response?.data?.errors || []);
      }

      if (response?.data?.successDetails?.length > 0) {
        window.exportPOSuccessesToCSV = () =>
          exportSuccessesToCSV(response?.data?.successDetails || []);
      }

      poResponseMessage = generateBulkUpdateResultHTML({
        additionalHeader: "PO Status Updates",
        additionalMessage: response?.data?.message,
        summary: response?.data?.summary,
        errors: response?.data?.errors,
        isPOUpdate: true,
      });
    } else if (poUpdateResonse?.error) {
      const { error } = poUpdateResonse;
      poResponseMessage = generateBulkUpdateResultHTML({
        additionalHeader: "Contractor Updates",
        additionalMessage: error?.response?.data?.message,
        isPOUpdate: true,
      });
    }

    dispatch({ type: BULK_UPDATE_CONTRACTOR_AND_PO_STATUS_SUCCESS });
    dispatch(
      alertDialogAciton({
        open: true,
        title: "Update Summary",
        message: contractorResponseMessage + "<br />" + poResponseMessage,
        maxWidth: "md",
      }),
    );
    successCallback?.({
      updatedRows: contractorUpdateResponse?.response?.data?.successDetails,
    });
  };
};

/**
 * api/v4/resendCredentials?id=6642467a0fb2fda384ac79ed
 */
export const resetContractorPasswordAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: RESET_CONTRACTOR_PASSWORD_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: "resendCredentials",
      params: payload?.params,
      isToken: true,
    });

    if (response?.status == 200) {
      dispatch({ type: RESET_CONTRACTOR_PASSWORD_SUCCESS });
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Success",
          message: response?.data?.message || "Password Successfully reset",
        }),
      );
      successCallback?.();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: RESET_CONTRACTOR_PASSWORD_FAILURE });
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message: error?.response?.data?.message || "Failed to reset password",
        }),
      );
      failureCallback?.();
    }
  };
};
